import CalculatorService from "../../../services/CalculatorService";
import emailMask from 'text-mask-addons/dist/emailMask'

class CalculatorEmailController {
  constructor($timeout, $filter, $http, NumberService, CalculatorService, $location) {
    this.name = 'calculator.email';
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.$http = $http;
    this.NumberService = NumberService;
    this.CalculatorService = CalculatorService;
    this.$location = $location;
  }

  $onInit() {
    this.extractFieldAnswers();
    this.calculate();

    this.purchaseCalculations = ['calculating mortgage amount', 'calculating mortgage payouts', 'calculating debt payouts', 'calculating title insurance fee', 'calculating registration fees', 'calculating legal fees', 'calculating amount paid to mortgagor', 'closing costs calculations completed'];
    this.saleCalculations = ['calculating balance due on closing', 'calculating realtor commission', 'calculating mortgage payouts', 'calculating legal fees', 'calculating amount paid to seller', 'closing costs calculations completed'];
    this.refinanceCalculations = ['calculating mortgage amount', 'calculating mortgage payouts', 'calculating debt payouts', 'calculating title insurance fee', 'calculating registration fees', 'calculating legal fees', 'calculating amount paid to mortgagor', 'closing costs calculations completed'];

    this.busy = true;
    this.delta = 1;
    this.value = 0.0;
    this.max = 100.0;
    this.animation = "easeInOutCubic";
    this.iterations = 200;
    this.label = "";
    this.label = this.value + "s";
    this.setStatusText(0);
    this.start();

    // set the email validator

    this.textMaskConfig = {
      mask: emailMask
    };
  }

  /**
   * extracts query params from url and returns an object from the query params
   * @param url
   * @returns {{}|*}
   */
  extractQueryParams(url) {
    try {
      const queryPart = url.match(/\?[^/]+/g);
      if (!queryPart) {
        return {};
      }
      return queryPart[0].replace(/^\?/g, '').replace('#!', '').split('&').reduce((o, str, index) => {
        const _split = str.split('=');
        if (_split.length >= 2 && !!_split[0]) {
          o[_split[0]] = decodeURI(
            _split.slice(1, _split.length).join('')
          );
        }
        return o;
      }, {});
    } catch (err) {
      return {};
    }
  }

  /**
   * this updates the value of the circle progress spinner
   */
  start() {
    if (this.value < (this.max)) {
      this.$timeout(() => {
        this.value = this.value + this.delta;
        this.label = Math.round(this.value) + '%';
        this.setStatusText(Math.round(this.value / this.stepSize));
        this.start();
      }, 15);
    } else {
      this.$timeout(() => {
        this.busy = false;
      }, 400);
    }
  }

  /**
   * sets the status text for what is currently loading
   * @param index
   */
  setStatusText(index) {
    switch (this.matterType) {
      case 'real_estate_purchase':
        this.statusLength = this.purchaseCalculations.length > 0 ? this.purchaseCalculations.length : 1;
        this.statusText = this.purchaseCalculations.length > index && index > -1 ? this.purchaseCalculations[index] : this.purchaseCalculations[this.purchaseCalculations.length - 1];
        break;
      case 'real_estate_sale':
        this.statusLength = this.saleCalculations.length > 0 ? this.saleCalculations.length : 1;
        this.statusText = this.saleCalculations.length > index && index > -1 ? this.saleCalculations[index] : this.saleCalculations[this.saleCalculations.length - 1];
        break;
      case 'mortgage_refinancing':
        this.statusLength = this.refinanceCalculations.length > 0 ? this.refinanceCalculations.length : 1;
        this.statusText = this.refinanceCalculations.length > index && index > -1 ? this.refinanceCalculations[index] : this.refinanceCalculations[this.refinanceCalculations.length - 1];
        break;
      default:
    }
    this.stepSize = 1.0 * this.max / this.statusLength;
  }

  /**
   * extacts all of the form pages field answers and creates an object containing fieldName => answer pair
   */
  extractFieldAnswers() {
    this.answers = {};
    if (this.allFields) {
      this.allFields.map(x => {
        x.fields.map(y => {
          if (y.type === 'currency') {
            this.answers[y.field] = this.NumberService.parseDecimal(y.value ? y.value : '');
          } else {
            this.answers[y.field] = y.value;
          }
        })
      });
    }
    this.answers.matterType = this.matterType;
  }

  /**
   * calls the calculator endpoint and calculates the required amount using the field answers
   */
  calculate() {
    this.CalculatorService.getCalculations(this.answers)
      .then(data => {
        switch (this.matterType) {
          case 'real_estate_purchase' :
            this.resultAmount = this.$filter('currency')(data.amountRequiredOnClosing);
            this.resultText = 'Estimated Amount You Need on Closing';
            this.resultText2 = 'See your Land Transfer Tax, Title Insurance Fee, Legal Fees & Registration Fees';
            break;
          case 'real_estate_sale' :
            this.resultAmount = this.$filter('currency')(data.amountYouReceiveOnClosing);
            this.resultText = 'Estimated Amount You Receive on Closing';
            this.resultText2 = 'See your Legal Fees, Payout Fees and Accounting with Your Realtor.';
            break;
          case 'mortgage_refinancing' :
            this.resultAmount = this.$filter('currency')(data.amountReceiveOnClosing);
            this.resultText = 'Estimated Amount You Receive on Closing';
            this.resultText2 = 'See your Title Insurance Fee, Legal Fees, Registration Fees & Mortgage Payout';
            break;
          default:
        }
      }).catch(err => {
      throw err;
    })
  }

  /**
   * go back to previous page
   */
  back() {
    this.goBack();
  }

  // used to check if user has clicked on one of email inputs
  outOfFocus(str) {
    switch (str) {
      case 'email':
        this.tEmail = true;
        break;
      case 'cc':
        this.tCc = true;
        break;
      default:
        break;
    }
  }

  /**
   * checks an email string and returns true if the email is correctly formatter.
   * email cannot start with a ., cannot have spaces, must have one @, must end with . something
   * @param str
   * @returns {boolean}
   */
  isValidEmail(str, isOption) {
//    if(str){
//      // (_)(_*)(_)@(_)(_*).(_+)
//      // 1st char : ~`!@#\$%\^&*()\-+={\[}\]|:;"'<,>\./\s\t\n
//      // after 1st char : ~`!@#\$%\^&*()\-+={\[}\]|:"'<,>/\s\t\n
//      // after @ char : ~`!@#\$%\^&*()\-+={\[}\]|:;"'<,>./\s\t\n
//      // let patt1 = /^[^~`!@#\$%\^&*()\-+={\[}\]|:;"'<,>\./\s\t\n][^~`!@#\$%\^&*()\-+={\[}\]|:"'<,>/\s\t\n]*@[^~`!@#\$%\^&*()\-+={\[}\]|:;"'<,>\./\s\t\n][^~`!@#\$%\^&*()\-+={\[}\]|:"'<,>/\s\t\n]*\.[^~`!@#\$%\^&*()\-+={\[}\]|:"'<,>/\s\t\n]+$/g;
//      let patt1 = /^[0-9a-zA-Z_].*[^\.\s]*@[^\.\s]*\..+$/g;
//      let r = str.match(patt1);
//      this.err = false;
//      return r ? true : false;
//    }else{
//      return isOption;
//    }
    return str ? true : false;
  }

  /**
   * send email with intake answers
   */
  sendEmail() {
    let validEmail = this.isValidEmail(this.email);
    let validCC = this.isValidEmail(this.cc);
    let valid = validEmail || validCC;

    let obj = {};
    let empty = false;

    if (this.email && !this.cc && validEmail) { // ensure that the email is valid
      obj = {
        calculatorData: this.answers,
        email: this.email,
        cc: null,
        promoCode: this.promoCode && this.promoCode != '' ? this.promoCode : null
      };
    } else if (!this.email && this.cc && validCC) { // ensure that the cc is valid
      obj = {
        calculatorData: this.answers,
        email: this.cc,
        cc: null,
        promoCode: this.promoCode && this.promoCode != '' ? this.promoCode : null
      };
    } else if (this.email && this.cc && validEmail && validCC) { // ensure that both are valid
      obj = {
        calculatorData: this.answers,
        email: this.email,
        cc: this.cc,
        promoCode: this.promoCode && this.promoCode != '' ? this.promoCode : null
      };
    } else { // do nothing
      empty = true;
    }

    let queryParamsObject = this.extractQueryParams(this.$location.absUrl());

    obj = Object.assign(obj, {ad_data: queryParamsObject});

    if (!empty) {
      gtag_report_conversion(); // call google analytics function defined in index.html
      // set this to true to prevent the message from being sent repeatedly
      this.sending = true;
      // request the calculator service to email calculations,
      this.CalculatorService.emailCalculations(obj).then(res => {
        // once done, we go to the final page
        this.goNext();
      }).catch(err => {
        this.sending = false;
        this.err = true;
        throw err;
      });
    }

  }
}

CalculatorEmailController.$inject = ['$timeout', '$filter', '$http', 'NumberService', 'CalculatorService', '$location'];

export default CalculatorEmailController;



// WEBPACK FOOTER //
// ./client/app/components/calculator/calculator.email/calculator.email.controller.js